import React, { useRef, useState } from "react";

import { t } from "i18next";

import PreregistrationSchoolsView from "./PreregistrationSchoolsView";

const initSchool = {
    id: "",
    schoolNumber: 0,
    name: "",
    schoolDeliveryType: "",
    preRegistrationStatus: 0,
    totalBooks: 0,
    booksToBeReturned: 0,
    booksNotToBeReturned: 0,
    booksToTakeOver: 0,
    booksNotToTakeOver: 0,
    schoolActiveNextYear: null,
    studentCount: 0,
};

function PreregistrationSchoolPage() {
    const tableTemplateRef = useRef(null);
    const [activeSchool, setActiveSchool] = useState(initSchool);

    return <PreregistrationSchoolsView activeSchool={activeSchool} tableTemplateRef={tableTemplateRef} />;
}

export default PreregistrationSchoolPage;
